/**
* [Flags]
*/
export var ResizeDirection;
(function (ResizeDirection) {
    ResizeDirection[ResizeDirection["None"] = 0] = "None";
    ResizeDirection[ResizeDirection["Left"] = 1] = "Left";
    ResizeDirection[ResizeDirection["Top"] = 2] = "Top";
    ResizeDirection[ResizeDirection["Right"] = 4] = "Right";
    ResizeDirection[ResizeDirection["Bottom"] = 8] = "Bottom";
    ResizeDirection[ResizeDirection["All"] = 15] = "All";
})(ResizeDirection || (ResizeDirection = {}));
;
